import { signOut } from '../../auth/sso';

// Internal-SSO logout — local-clear-first, then auth-site RP-initiated logout.
// Goes through signOut() so the route guard stands down instead of racing the redirect.
export default function useSignout() {
  return signOut;
}
